import 'moment/locale/fi';
import React, { createElement } from 'react';
import { Table } from 'react-bootstrap';
import { getActiveLanguage, getTranslate } from 'react-localize-redux';
import { connect } from 'react-redux';
import Modal from 'react-responsive-modal';
import { Prompt } from 'react-router';
import { toast } from 'react-toastify';
import { bindActionCreators } from 'redux';
import moment from 'moment';
import { downloadFile, installationDocumentOrderUpload, installationDocumentRequestApi } from '../actions/helper';
import { enableSubNavbar, setSubNavbar } from '../actions/navbar';
import Input from '../components/forms/Input';
import Select from '../components/forms/Select';
import './InstallationService.css';
import InstallationServiceSubcontractor from './InstallationServiceSubcontractor';
import InstallationServiceDevices from './InstallationServiceDevices';
import InstallationServiceForm from './InstallationServiceForm';
import InstallationServiceComments from './InstallationServiceComments';
import InstallationServiceParking from './InstallationServiceParking';
import InstallationServiceAdditionalServices from './InstallationServiceAdditionalServices';
import InstallationServiceAttachments from './InstallationServiceAttachments';
import InstallationServiceEditAttachments from './InstallationServiceEditAttachments';
import InstallationServiceShipmentModal from './InstallationServiceShipmentModal';
import TimeData from './TimeData';
import ReasonFields from './ReasonFields';
import dayjs from 'dayjs';
import DayPickerInput from 'react-day-picker/DayPickerInput';

let submitFormModalOpen = false;
let formStatusToSave = '';
let proceedShipmentOrder = false;

const subcontractorPostiOY = '0109357-9';

const statusValues = {
  ORDERED: 'WEB_TO_WEB_ORDERED',
  TIMEAGREED: 'WEB_TO_WEB_TIME_AGREED',
  UNCOMPLETED: 'WEB_TO_WEB_UNCOMPLETED',
  WEB_TO_APK_UNCOMPLETED: 'WEB_TO_APK_UNCOMPLETED',
  WEB_TO_APK_COMPLETED: 'WEB_TO_APK_COMPLETED',
  APK_TO_APK_UNCOMPLETED: 'APK_TO_APK_UNCOMPLETED',
  APK_TO_APK_COMPLETED: 'APK_TO_APK_COMPLETED',
  APK_TO_WEB_COMPLETED: 'APK_TO_WEB_COMPLETED',
  APK_TO_WEB_UNCOMPLETED: 'APK_TO_WEB_UNCOMPLETED',
  APK_TO_WEB_TIME_AGREED: 'APK_TO_WEB_TIME_AGREED',
  APK_TO_WEB_CANCELLED: 'APK_TO_WEB_CANCELLED',
  APK_TO_WEB_CUSTOMER_UNREACHABLE: 'APK_TO_WEB_CUSTOMER_UNREACHABLE',

  CANCELLED: 'WEB_TO_WEB_CANCELLED',
  COMPLETED: 'WEB_TO_WEB_COMPLETED',
  WEB_TO_WEB_CUSTOMER_UNREACHABLE: 'WEB_TO_WEB_CUSTOMER_UNREACHABLE',

};

const deviceStatusValues = {
  COMPLETED: 'COMPLETED',
  UNCOMPLETED: 'UNCOMPLETED',
  NOT_INSTALLED: 'NOT_INSTALLED',
};

const statusList = [
  {
    value: statusValues.ORDERED,
    shouldShowTimeField: false,
    shouldShowSelectDateOrReasonForm: false,
    visibleOption: true,
  },
  {
    value: statusValues.COMPLETED,
    shouldShowTimeField: true,
    shouldShowSelectDateOrReasonForm: true,
    visibleOption: true,
  },
  {
    value: statusValues.TIMEAGREED,
    shouldShowTimeField: true,
    shouldShowSelectDateOrReasonForm: true,
    visibleOption: true,
  },
  {
    value: statusValues.UNCOMPLETED,
    shouldShowTimeField: false,
    shouldShowSelectDateOrReasonForm: true,
    visibleOption: true,
  },
  {
    value: statusValues.CANCELLED,
    shouldShowTimeField: false,
    shouldShowSelectDateOrReasonForm: true,
    visibleOption: true,
  },
  {
    value: statusValues.WEB_TO_APK_COMPLETED,
    shouldShowTimeField: false,
    shouldShowSelectDateOrReasonForm: false,
    visibleOption: false,
  },
  {
    value: statusValues.WEB_TO_APK_UNCOMPLETED,
    shouldShowTimeField: false,
    shouldShowSelectDateOrReasonForm: false,
    visibleOption: false,
  },
  {
    value: statusValues.APK_TO_APK_COMPLETED,
    shouldShowTimeField: false,
    shouldShowSelectDateOrReasonForm: false,
    visibleOption: false,
  },
  {
    value: statusValues.APK_TO_APK_UNCOMPLETED,
    shouldShowTimeField: false,
    shouldShowSelectDateOrReasonForm: false,
    visibleOption: false,
  },
  {
    value: statusValues.APK_TO_WEB_COMPLETED,
    shouldShowTimeField: false,
    shouldShowSelectDateOrReasonForm: false,
    visibleOption: false,
  },
  {
    value: statusValues.APK_TO_WEB_UNCOMPLETED,
    shouldShowTimeField: false,
    shouldShowSelectDateOrReasonForm: false,
    visibleOption: false,
  },
  {
    value: statusValues.APK_TO_WEB_TIME_AGREED,
    shouldShowTimeField: false,
    shouldShowSelectDateOrReasonForm: false,
    visibleOption: false,
  },
  {
    value: statusValues.APK_TO_WEB_CANCELLED,
    shouldShowTimeField: false,
    shouldShowSelectDateOrReasonForm: false,
    visibleOption: false,
  },
  {
    value: statusValues.WEB_TO_WEB_CUSTOMER_UNREACHABLE,
    shouldShowTimeField: true,
    shouldShowSelectDateOrReasonForm: true,
    visibleOption: true,
  },
  {
    value: statusValues.APK_TO_WEB_CUSTOMER_UNREACHABLE,
    shouldShowTimeField: false,
    shouldShowSelectDateOrReasonForm: false,
    visibleOption: false,
  },
];

class InstallationDocument extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      installationDocumentId: null,
      isChanged: false,
      shipmentNumber: '',
      shipmentType: '',
      consignorName: '',
      customerName: '',
      companyName: '',
      customerAddress: '',
      customerPostcode: '',
      customerCity: '',
      customerPhone: '',
      customerPhone2: '',
      customerEmail: '',
      invoiceReference: '',
      invoiceReference2: '',
      selectedDevices: [],
      selectedDeviceAdditionalProducts: [],
      selectedSubcontractor: '',
      installationComment: '',
      installationAttachments: [],
      currentFormStatus: statusValues.ORDERED,
      currentFormStatusDB: '',
      editStateImportedTime: [],
      orderUncompletedCancelledReasonText: '',
      importedJson: '',
      originalData: {
        shipmentNumber: '',
        shipmentType: '',
        consignorName: '',
        customerName: '',
        companyName: '',
        customerAddress: '',
        customerPostcode: '',
        customerCity: '',
        customerPhone: '',
        customerPhone2: '',
        customerEmail: '',
        invoiceReference: '',
        invoiceReference2: '',
        selectedDevices: [],
        selectedDeviceAdditionalProducts: [],
        selectedSubcontractor: '',
        installationComment: '',
        installationAttachments: [],
        currentFormStatus: statusValues.ORDERED,
        editStateImportedTime: [],
        orderUncompletedCancelledReasonText: '',
      },
      importedDevices: [],
      importedDeviceAdditionalProducts: [],
      importedSubcontractors: [],
      shipmentRequestLoading: false,
      shipmentModalOpen: false,
      adminEditInstallationAttachmentModalOpen: false,
      currentFileToBeRemoved: null,
      newInstallationAttachmentsEdit: [],
      removedInstallationAttachmentsEdit: [],
      isEditState: false,
      editStateTimeDate: '',
      editStateTimeStart: '',
      editStateTimeEnd: '',
      isSubmittingOrder: false,
      updatedStatusList: [],
      isAllDevicesCompleted: true,
      previousStatus: {},
      mergedStatus: [],
      parkingInfo: '',
      hasAtleastOneDevice: true,
    };
  }

  componentWillMount() {
    const { installationDocumentId = null } = this.props.location.state;
    this.reloadData(installationDocumentId);
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  componentDidUpdate() {
    const {
      translate,
      setSubNavbar: setNavbar,
    } = this.props;
    const { installationDocumentId } = this.state;

    const backLink = installationDocumentId === null
      ? '/'
      : '/worklist';
    setNavbar({
      title: [
        translate('navigation.installationservice'),
      ],
      backLink,
    });
  }

  openSubmitFormModal = () => {
    submitFormModalOpen = true;
  };

  closeSubmitFormModal = () => {
    submitFormModalOpen = false;
    this.setState({
      isSubmittingOrder: false,
    });
  };

  reloadData = (installationDocumentId) => {
    this.fetchDevices();
    this.fetchSubcontractors();
    if (installationDocumentId === null) {
      this.setState({
        installationDocumentId,
        isEditState: false,
      });
    } else {
      this.fetchEditData(installationDocumentId);
    }
    this.fetchAddedServices();
  };

  fetchDevices = () => {
    installationDocumentRequestApi('/installationdocument/devices')
      .then((importedDevices) => {
        if (importedDevices != null) {
          this.setState({
            importedDevices,
          });
        }
      });
  };

  fetchSubcontractors = () => {
    installationDocumentRequestApi('/installationdocument/order/subcontractors')
      .then((importedSubcontractors) => {
        if (importedSubcontractors != null) {
          this.setState({
            importedSubcontractors,
          });
        }
      });
  };

  fetchAddedServices = () => {
    installationDocumentRequestApi('/installationdocument/order/deviceadditionalproducts')
      .then((importedDeviceAdditionalProducts) => {
        if (importedDeviceAdditionalProducts != null) {
          this.setState({
            importedDeviceAdditionalProducts,
          });
        }
      });
  };

  getCurrentFormStatus = (status) => {
    const { session: { isAdmin = false } } = this.props;
    let currentStatus = '';
    if (!isAdmin && status === statusValues.ORDERED) {
      currentStatus = statusList.find((u) => u.value === statusValues.TIMEAGREED);
    } else if (status.endsWith('_UNCOMPLETED')) {
      currentStatus = statusList.find((u) => u.value === statusValues.UNCOMPLETED);
    } else if (status.endsWith('_COMPLETED')) {
      currentStatus = statusList.find((u) => u.value === statusValues.COMPLETED);
    } else if (status.endsWith('_CANCELLED')) {
      currentStatus = statusList.find((u) => u.value === statusValues.CANCELLED);
    } else if (status.endsWith('_TIME_AGREED')) {
      currentStatus = statusList.find((u) => u.value === statusValues.TIMEAGREED);
    } else if (!status.endsWith('_AGREED') && (!status.endsWith('_ORDERED'))) {
      currentStatus = statusList.find((u) => u.value === statusValues.WEB_TO_WEB_CUSTOMER_UNREACHABLE);
    } else {
      currentStatus = statusList.find((u) => u.value === status);
    }
    return currentStatus;
  }

  storeStateData = (source, importedEditJson) => {
    const { session: { isAdmin = false } } = this.props;
    const {
      importedSubcontractors,
      anyUncompletedDevice,
    } = this.state;
    formStatusToSave = this.getCurrentFormStatus(importedEditJson.status.value);
    // eslint-disable-next-line
    importedEditJson.devices.forEach((device) => {
      if (device.status !== undefined && anyUncompletedDevice === undefined) {
        if (device.status.value === 'UNCOMPLETED') {
          this.setState({ anyUncompletedDevice: true });
        }
      } else if (device.status !== undefined && device.status.value === 'NOT_INSTALLED' && anyUncompletedDevice === undefined) {
        this.setState({ isAllDevicesCompleted: false });
      } else if (device.status === undefined && anyUncompletedDevice === undefined) {
        this.setState({ isAllDevicesCompleted: false });
      }
    });
    this.setState({ installationLastStatus: importedEditJson.status.value });

    return {
      ...source,
      shipmentNumber: importedEditJson.devices[0].shipmentId,
      shipmentType: importedEditJson.devices[0].shipmentType,
      consignorName: importedEditJson.orderData.consignorName,
      parkingInfo: importedEditJson.customer.parkingInfo,
      customerName: importedEditJson.customer.name,
      companyName: importedEditJson.orderData.companyName,
      customerAddress: importedEditJson.customer.streetAddress,
      customerPostcode: importedEditJson.customer.postalCode,
      customerCity: importedEditJson.customer.city,
      customerPhone: importedEditJson.customer.phone,
      customerPhone2: importedEditJson.customer.phone2,
      customerEmail: importedEditJson.customer.eMail,
      customerSignature: importedEditJson.customer.signatureName,
      nameClarification: importedEditJson.customer.nameClarification !== undefined ? importedEditJson.customer.nameClarification : '',
      pdfName: importedEditJson.customer.pdfName,
      invoiceReference: importedEditJson.orderData.invoiceReference,
      invoiceReference2: importedEditJson.orderData.invoiceReference2,
      selectedDevices: importedEditJson.devices,
      selectedDeviceAdditionalProducts: importedEditJson.orderData.deviceAdditionalProducts,
      selectedSubcontractor: (!this.isDefined(importedEditJson.orderData.subcontractor) || importedEditJson.orderData.subcontractor === '')
        ? importedSubcontractors.find((u) => u.companyBusinessId === subcontractorPostiOY) : importedEditJson.orderData.subcontractor,
      installationComment: importedEditJson.orderData.installationComment,
      installationAttachments: importedEditJson.orderData.files,
      currentFormStatus: this.getCurrentFormStatus(importedEditJson.status.value),
      currentFormStatusDB: importedEditJson.status,
      isOrderedOptionDisabled: (!isAdmin || importedEditJson.status.value !== statusValues.ORDERED),
      editStateImportedTime: importedEditJson.status.timeAgreementDates,
      orderUncompletedCancelledReasonText: importedEditJson.status.reason,
      previousStatus: importedEditJson.status,
      mergedStatus: importedEditJson.mergedStatuses,
    };
  };

  removeInvisibleOptions = (list, status) => {
    const currentDocumentStatus = status.value !== undefined ? status.value : '';
    const returnList = [];
    for (let i = 0; i < list.length; i++) {
      if (list[i].visibleOption === true) {
        if (currentDocumentStatus !== '' && currentDocumentStatus.endsWith('_AGREED') && !list[i].value.endsWith('_UNREACHABLE')) {
          returnList.push(list[i]);
        } else if (currentDocumentStatus !== '' && (currentDocumentStatus.endsWith('_ORDERED')
            || currentDocumentStatus.endsWith('_UNCOMPLETED') || currentDocumentStatus.endsWith('_COMPLETED')
            || currentDocumentStatus.endsWith('_UNREACHABLE') || currentDocumentStatus.endsWith('_CANCELLED'))) {
          returnList.push(list[i]);
        }
      }
    }
    return returnList;
  }

  fetchEditData = (installationDocumentId) => {
    installationDocumentRequestApi(`/installationdocument/order/search/${installationDocumentId}`)
      .then((importedEditJson) => {
        if (importedEditJson != null) {
          let state = {
            isEditState: true,
            installationDocumentId,
            importedJson: importedEditJson,
          };
          state = this.storeStateData(state, importedEditJson);
          state.originalData = this.storeStateData({}, importedEditJson);

          state.updatedStatusList = [];
          if (!state.isOrderedOptionDisabled) {
            // In this case we use all statuses from statusList array
            state.updatedStatusList = state.updatedStatusList.concat(this.removeInvisibleOptions(statusList, importedEditJson.status));
          } else {
            // In this case we remove WEB_TO_WEB_ORDERED status
            // WEB_TO_WEB_ORDERED status is first in statusList array
            state.updatedStatusList = this.removeInvisibleOptions(statusList.slice(1, statusList.length), importedEditJson.status);
          }

          this.setState(state, () => this.setEditTimeFields(importedEditJson.status.timeAgreementDates));
        }
      })
      .catch((err) => toast.error(err.message));
  };

  setEditTimeFields = (editStateImportedTime) => {
    const agreedDatesLastElement = JSON.parse(JSON.stringify(editStateImportedTime))
      .reverse()[0];
    const isTimeDefined = this.isDefined(agreedDatesLastElement)
        && this.isDefined(agreedDatesLastElement.startDate);

    this.setState({
      editStateTimeDate: isTimeDefined ? agreedDatesLastElement.startDate : new Date(),
      editStateTimeStart: isTimeDefined ? agreedDatesLastElement.startDate : new Date(),
      editStateTimeEnd: isTimeDefined ? agreedDatesLastElement.endDate : new Date(),
    });
  };

  isDefined = (value) => typeof value !== 'undefined';

  shipmentDataConfirmation = (shipmentNumber) => {
    if (shipmentNumber !== '') {
      const {
        customerName, customerAddress, customerPostcode, customerCity, customerPhone, customerEmail,
        consignorName, selectedDevices, selectedDeviceAdditionalProducts, shipmentType,
      } = this.state;

      const customerFields = [customerName, customerAddress, customerPostcode, customerCity, customerPhone, customerEmail, consignorName, shipmentType];
      const productFields = [selectedDevices, selectedDeviceAdditionalProducts];
      if (customerFields.some((x) => x !== '')
          || productFields.some((x) => x.length)) {
        this.setState({
          shipmentRequestLoading: true,
          shipmentModalOpen: true,
        });
      } else {
        this.setState({
          shipmentRequestLoading: true,
        });
        this.fetchShipmentData(shipmentNumber);
      }
    }
  };

  emptyFieldsAndFetchShipmentData = (shipmentNumber) => {
    this.setState({
      shipmentType: '',
      customerName: '',
      customerAddress: '',
      customerPostcode: '',
      customerCity: '',
      customerPhone: '',
      customerEmail: '',
      consignorName: '',
      selectedDevices: [],
      selectedDeviceAdditionalProducts: [],
    });
    this.fetchShipmentData(shipmentNumber);
  };

  fetchShipmentData = (shipmentNumber) => {
    const { translate } = this.props;
    this.setState({ shipmentModalOpen: false });
    const webUIRequestAlias = 'web_ui';
    installationDocumentRequestApi(`/installationdocument/shipments/${shipmentNumber}?from=${webUIRequestAlias}`)
      .then((shipmentData) => {
        if (this.isDefined(shipmentData)) {
          if (this.isDefined(shipmentData.status)) {
            toast.error(translate('service_installation.error.shipment_already_exists'));
            this.setState({
              shipmentNumber: '',
              isChanged: false,
            });
          } else {
            this.prefillCustomerData(shipmentData);
          }
        } else {
          // not found
          toast.error(translate('service_installation.error.shipment_not_found'));
          this.setState({
            shipmentNumber: '',
            isChanged: false,
          });
        }
      })
      .finally(() => this.setState({ shipmentRequestLoading: false }));
  };

  prefillCustomerData = (shipmentData) => {
    const {
      importedDevices, selectedDevices, importedDeviceAdditionalProducts,
      selectedDeviceAdditionalProducts,
    } = this.state;
    const serviceArray = shipmentData.Services.Service;

    if (this.isDefined(serviceArray)) {
      serviceArray.forEach((service) => {
        importedDevices.forEach((device) => {
          if (service.value === device.code || service.value === device.tmsCode) {
            selectedDevices.push(device);
          }
        });
        importedDeviceAdditionalProducts.forEach((additionalService) => {
          if (service.value === additionalService.code || service.value === additionalService.tmsCode) {
            selectedDeviceAdditionalProducts.push(additionalService);
          }
        });
      });
    }

    this.setState({
      shipmentType: shipmentData.ShipmentType,
      customerName: shipmentData.Customer.Name,
      customerAddress: shipmentData.Customer.Address,
      customerPostcode: shipmentData.Customer.Postcode,
      customerCity: shipmentData.Customer.City,
      customerPhone: shipmentData.Customer.Phone,
      customerEmail: shipmentData.Customer.Email,
      consignorName: shipmentData.Consignor.Name1,
    });
  };

  createOrUpdateShipment = (formData) => {
    const {
      shipmentNumber, shipmentType, consignorName, customerName, companyName, customerAddress, customerPostcode,
      customerCity, customerPhone, customerPhone2, customerEmail, invoiceReference,
      invoiceReference2, selectedDevices, selectedDeviceAdditionalProducts, selectedSubcontractor,
      installationComment, installationAttachments, isEditState, newInstallationAttachmentsEdit,
      removedInstallationAttachmentsEdit, currentFormStatus, orderUncompletedCancelledReasonText,
      editStateImportedTime, importedJson, editStateTimeStart, editStateTimeEnd, previousStatus,
      editStateTimeDate, parkingInfo, customerSignature, nameClarification, pdfName,
    } = this.state;
    const { currentLanguage, translate } = this.props;

    if (this.validateFormFailure()) {
      this.setState({
        isSubmittingOrder: false,
      });
      return;
    }

    let jsonState;
    const mergedStatuses = [];
    const agreedDateTimes = [];
    if (!isEditState) {
      const files = [];
      installationAttachments.forEach((file) => {
        formData.append('files', file);
        files.push(file.name);
      });

      jsonState = {
        shipmentNumber,
        shipmentType,
        consignorName,
        customerName,
        companyName,
        customerSignature,
        customerAddress,
        customerPostcode,
        customerCity,
        parkingInfo,
        customerPhone,
        customerPhone2,
        customerEmail,
        invoiceReference,
        invoiceReference2,
        devices: selectedDevices,
        deviceAdditionalProducts: selectedDeviceAdditionalProducts,
        subcontractor: selectedSubcontractor,
        installationComment,
        files,
        status: currentFormStatus,
        date: new Date(),
      };
    } else {
      const filesFromBE = installationAttachments.filter((val) => !newInstallationAttachmentsEdit.includes(val));

      if (!newInstallationAttachmentsEdit.length) {
        formData.append('files', '');
      } else {
        newInstallationAttachmentsEdit.forEach((file) => {
          formData.append('files', file);
        });
      }

      jsonState = {
        shipmentNumber,
        devices: selectedDevices,
        status: formStatusToSave,
        removedFiles: removedInstallationAttachmentsEdit,
        id: importedJson.id,
        createdAt: importedJson.createdAt,
        updatedAt: importedJson.updatedAt,
      };

      jsonState.customer = {
        name: customerName,
        streetAddress: customerAddress,
        postalCode: customerPostcode,
        city: customerCity,
        phone: customerPhone,
        phone2: customerPhone2,
        eMail: customerEmail,
        language: currentLanguage,
        parkingInfo,
      };

      jsonState.orderData = {
        subcontractor: selectedSubcontractor,
        deviceAdditionalProducts: selectedDeviceAdditionalProducts,
        files: filesFromBE,
        consignorName,
        companyName,
        invoiceReference,
        invoiceReference2,
        installationComment,
      };

      const selectedStartTimeAndDate = new Date(new Date(editStateTimeDate).getFullYear(), new Date(editStateTimeDate).getMonth(),
        new Date(editStateTimeDate).getDate(), new Date(editStateTimeStart).getHours(), new Date(editStateTimeStart).getMinutes(), 0, 0);

      let selectedEndTimeAndDate = new Date(new Date(editStateTimeDate).getFullYear(), new Date(editStateTimeDate).getMonth(),
        new Date(editStateTimeDate).getDate(), new Date(editStateTimeEnd).getHours(), new Date(editStateTimeEnd).getMinutes(), 0, 0);
      if (formStatusToSave.value === statusValues.WEB_TO_WEB_CUSTOMER_UNREACHABLE || formStatusToSave.value === statusValues.APK_TO_WEB_CUSTOMER_UNREACHABLE) {
        selectedEndTimeAndDate = selectedStartTimeAndDate;
      }

      if (currentFormStatus.shouldShowTimeField) {
        const newDate = {
          startDate: selectedStartTimeAndDate,
          endDate: selectedEndTimeAndDate,
          agreementStatus: formStatusToSave.value,
        };

        const newAgreedStartTime = moment(newDate.startDate).local().format('HH:mm');
        const newAgreedEndTime = moment(newDate.endDate).local().format('HH:mm');
        const newAgreedDate = moment(newDate.endDate).local().format('DD.MM.YYYY');

        const contains = editStateImportedTime.some((agreedTime) => {
          const startTimeAgreed = moment(agreedTime.startDate).local().format('HH:mm');
          const endTimeAgreed = moment(agreedTime.endDate).local().format('HH:mm');
          const agreedDate = moment(agreedTime.endDate).local().format('DD.MM.YYYY');
          return (newAgreedStartTime === startTimeAgreed) && (newAgreedEndTime === endTimeAgreed) && (newAgreedDate === agreedDate);
        });

        if (previousStatus.value === currentFormStatus.value) {
          // eslint-disable-next-line
          previousStatus.timeAgreementDates.map((p) => {
            agreedDateTimes.push(p);
          });

          agreedDateTimes.push({
            startDate: selectedStartTimeAndDate,
            endDate: selectedEndTimeAndDate,
            agreementStatus: formStatusToSave.value,
          });
          mergedStatuses.push({
            value: previousStatus.value,
            timeAgreementDates: agreedDateTimes,
          });
        } else {
          mergedStatuses.push({
            value: currentFormStatus.value,
            timeAgreementDates: {
              startDate: selectedStartTimeAndDate,
              endDate: selectedEndTimeAndDate,
              agreementStatus: formStatusToSave.value,
            },
          });
          mergedStatuses.push({
            value: previousStatus.value,
            timeAgreementDates: previousStatus.timeAgreementDates,
          });
        }

        if (!contains) {
          editStateImportedTime.push(newDate);
        }
      } else {
        jsonState.status.reason = orderUncompletedCancelledReasonText;
      }
      jsonState.customer.signatureName = customerSignature;
      jsonState.customer.nameClarification = nameClarification;
      jsonState.customer.pdfName = pdfName;

      jsonState.date = new Date();
      jsonState.mergedStatuses = mergedStatuses;
      jsonState.status.timeAgreementDates = editStateImportedTime;
    }
    formData.append('installationorder', JSON.stringify(jsonState));

    const requestProperties = {
      // FIXME Should be changed to PATCH method from `/edit` url.
      method: 'POST',
      body: formData,
    };

    let url = '/installationdocument/order';
    if (isEditState) {
      url += '/edit';
    }

    let hasError = false;
    const isCustomerPhoneValid = (/^[-+0-9]+$/.test(jsonState.customerphone));
    const isCustomerPhone2Valid = (/^[-+0-9]+$/.test(jsonState.customerphone2));
    const isCustomerEmailValid = (/^[%_a-zA-Z0-9.-]+@[-a-zA-Z0-9]+\.[A-Za-z]+$/.test(jsonState.customereMail));

    if (!isCustomerEmailValid && jsonState.customereMail !== undefined && jsonState.customereMail !== '') {
      hasError = true;
      toast.error(translate('service_installation.invalid_customer_email'));
    }

    if (!isCustomerPhoneValid && jsonState.customerphone !== undefined && jsonState.customerphone !== '') {
      hasError = true;
      toast.error(translate('service_installation.invalid_customer_phone'));
    }

    if (!isCustomerPhone2Valid && jsonState.customerphone2 !== undefined && jsonState.customerphone2 !== '') {
      hasError = true;
      toast.error(translate('service_installation.invalid_customer_phone2'));
    }

    if (!hasError) {
      installationDocumentOrderUpload(requestProperties, url)
        .then((response) => {
          this.installationOrderUploadResult(response);
          this.setState({
            isChanged: false,
          });
          if (!response.ok) {
            // in case when response is ok installationOrderUploadResult reloads window so there is no need to change the state.
            this.setState({
              isSubmittingOrder: false,
            });
          }
        })
        .catch(() => {
          this.setState({
            isSubmittingOrder: false,
          });
        });
    } else {
      this.setState({
        isSubmittingOrder: false,
      });
    }
  };

  installationOrderUploadResult = (response) => {
    const { translate } = this.props;
    if (!response.ok) {
      toast.error(translate('service_installation.order_confirm_error'));
    } else {
      toast(translate('service_installation.order_confirm_success'));
      setTimeout(() => {
        window.location.reload(false);
      }, 1000);
    }
  };

  reset = () => {
    this.setState({
      isChanged: false,
    });
  };

  completeInstallationDocument = (evt, completeInstallationDocument) => {
    const {
      currentFormStatusDB,
    } = this.state;

    let installationDocumentStatus = formStatusToSave;
    if (completeInstallationDocument) {
      if (currentFormStatusDB.value.startsWith('APK_TO_')) {
        installationDocumentStatus = statusList.find((u) => u.value === statusValues.APK_TO_WEB_COMPLETED);
      } else if (currentFormStatusDB.value.startsWith('WEB_TO_')) {
        installationDocumentStatus = statusList.find((u) => u.value === statusValues.COMPLETED);
      }
      submitFormModalOpen = false;
      formStatusToSave = installationDocumentStatus;
      proceedShipmentOrder = true;

      this.processShipmentOrder(evt);
    } else {
      this.closeSubmitFormModal();
    }
  }

  updateFormStatusBeforeSaving = () => {
    const {
      currentFormStatus,
      currentFormStatusDB,
    } = this.state;

    if (currentFormStatusDB.value.startsWith('APK_TO_')) {
      switch (currentFormStatus.value) {
        case statusValues.COMPLETED:
          formStatusToSave = statusList.find((u) => u.value === statusValues.APK_TO_WEB_COMPLETED);
          break;
        case statusValues.UNCOMPLETED:
          formStatusToSave = statusList.find((u) => u.value === statusValues.APK_TO_WEB_UNCOMPLETED);
          break;
        case statusValues.TIMEAGREED:
          formStatusToSave = statusList.find((u) => u.value === statusValues.APK_TO_WEB_TIME_AGREED);
          break;
        case statusValues.WEB_TO_WEB_CUSTOMER_UNREACHABLE:
          formStatusToSave = statusList.find((u) => u.value === statusValues.APK_TO_WEB_CUSTOMER_UNREACHABLE);
          break;
        case statusValues.CANCELLED:
          formStatusToSave = statusList.find((u) => u.value === statusValues.APK_TO_WEB_CANCELLED);
          break;
        default:
          break;
      }
    }
  }

  processShipmentOrder = (evt) => {
    evt.preventDefault();

    const { translate } = this.props;
    const {
      shipmentNumber,
      isEditState,
      currentFormStatus,
      currentFormStatusDB,
      isAllDevicesCompleted,
    } = this.state;
    const formData = new FormData(document.forms.installationDocumentForm);
    this.setState({
      isSubmittingOrder: true,
    });

    if (isEditState) {
      if (currentFormStatus.value === statusValues.COMPLETED
          && currentFormStatusDB.value !== statusValues.COMPLETED
          && !proceedShipmentOrder) {
        this.openSubmitFormModal();
      } else {
        this.updateFormStatusBeforeSaving();
        this.createOrUpdateShipment(formData);
      }
    } else if (isAllDevicesCompleted) {
      installationDocumentRequestApi(`/installationdocument/shipments/${shipmentNumber}?from=web_ui`)
        .then((shipmentData) => {
          if (this.isDefined(shipmentData) && !this.isDefined(shipmentData.status)) {
            this.createOrUpdateShipment(formData);
          } else {
            toast.error(translate('service_installation.order_confirm_shipment_number_not_acceptable'));
            this.setState({
              isSubmittingOrder: false,
            });
          }
        })
        .catch(() => {
          this.setState({
            isSubmittingOrder: false,
          });
        });
    }
  };

  validateFormFailure = () => {
    const { translate } = this.props;
    const {
      shipmentNumber, consignorName, customerName, customerAddress, customerPostcode, customerCity,
      customerPhone, customerEmail, selectedDevices, selectedSubcontractor,
    } = this.state;

    let isFormFailed = false;

    if (shipmentNumber === '') {
      toast.error(`${translate('service_installation.fill_the_following_fields')} ${translate('service_installation.jjfi_code')}`);
      isFormFailed = true;
    }

    if (consignorName === '') {
      toast.error(`${translate('service_installation.fill_the_following_fields')} ${translate('service_installation.sender')}`);
      isFormFailed = true;
    }

    if (customerName === '') {
      toast.error(`${translate('service_installation.fill_the_following_fields')} ${translate('service_installation.name')}`);
      isFormFailed = true;
    }

    if (customerAddress === '') {
      toast.error(`${translate('service_installation.fill_the_following_fields')} ${translate('service_installation.address')}`);
      isFormFailed = true;
    }

    if (customerPostcode === '') {
      toast.error(`${translate('service_installation.fill_the_following_fields')} ${translate('service_installation.postal_code')}`);
      isFormFailed = true;
    }

    if (customerCity === '') {
      toast.error(`${translate('service_installation.fill_the_following_fields')} ${translate('service_installation.city')}`);
      isFormFailed = true;
    }

    if (customerPhone === '' && customerEmail === '') {
      toast.error(translate('service_installation.add_either_phone_or_email'));
      isFormFailed = true;
    }

    if (selectedSubcontractor === '') {
      toast.error(`${translate('service_installation.fill_the_following_fields')} ${translate('service_installation.subcontractor_title')}`);
      isFormFailed = true;
    }

    if (!selectedDevices.length) {
      toast.error(translate('service_installation.add_at_least_one_device_error'));
      isFormFailed = true;
    }

    return isFormFailed;
  };

  downloadPDF = () => {
    const { pdfName } = this.state;
    downloadFile(pdfName, '/installationdocument/report/pdf');
  };

  renderInstallationServiceForm = () => {
    const { session: { isAdmin = false } } = this.props;
    const {
      shipmentNumber, shipmentType, consignorName, customerName, companyName, customerAddress, customerPostcode,
      customerPhone, customerPhone2, customerEmail, customerCity, invoiceReference, invoiceReference2,
      isEditState, shipmentRequestLoading, pdfName,
    } = this.state;

    return (
      <fieldset disabled={!isAdmin && isEditState}>
        <InstallationServiceForm shipmentNumber={shipmentNumber}
                                 shipmentType={shipmentType}
                                 consignorName={consignorName}
                                 customerName={customerName}
                                 companyName={companyName}
                                 customerAddress={customerAddress}
                                 customerPostcode={customerPostcode}
                                 customerPhone={customerPhone}
                                 customerPhone2={customerPhone2}
                                 customerEmail={customerEmail}
                                 customerCity={customerCity}
                                 invoiceReference={invoiceReference}
                                 invoiceReference2={invoiceReference2}
                                 shipmentRequestLoading={shipmentRequestLoading}
                                 onHandleChange={this.handleChange}
                                 isEditState={isEditState}
                                 isAdmin={isAdmin}
                                 pdfName={pdfName}
                                 pdfDownloadHandler={this.downloadPDF}
                                 onDataConfirmation={this.shipmentDataConfirmation} />
      </fieldset>
    );
  };

  renderShipmentDataModal = () => {
    const {
      shipmentModalOpen, shipmentNumber,
    } = this.state;

    const closeShipmentDataModal = () => {
      this.setState({
        shipmentModalOpen: false,
        shipmentRequestLoading: false,
      });
    };

    return (
      <InstallationServiceShipmentModal shipmentModalOpen={shipmentModalOpen}
                                        shipmentNumber={shipmentNumber}
                                        closeShipmentDataModal={closeShipmentDataModal}
                                        onEmptyFieldsAndFetchShipmentData={this.emptyFieldsAndFetchShipmentData} />
    );
  };

  renderEditInstallationsAttachmentFileDeleteModal = () => {
    const {
      adminEditInstallationAttachmentModalOpen,
      currentFileToBeRemoved,
      isEditState,
    } = this.state;
    if (!isEditState) {
      return '';
    }

    const closeAdminEditInstallationAttachmentVerify = () => {
      this.setState({
        adminEditInstallationAttachmentModalOpen: false,
      });
    };

    return (
      <InstallationServiceEditAttachments adminEditInstallationAttachmentModalOpen={adminEditInstallationAttachmentModalOpen}
                                          currentFileToBeRemoved={currentFileToBeRemoved}
                                          closeAdminEditInstallationAttachmentVerify={closeAdminEditInstallationAttachmentVerify}
                                          onAttachmentsRemove={this.installationAttachmentsRemove} />
    );
  };

  renderSubcontractorForm = () => {
    const { session: { isAdmin = false } } = this.props;
    const {
      importedSubcontractors,
      selectedSubcontractor,
      isEditState,
    } = this.state;

    const subcontractorChanged = (evt) => {
      const { target: { value } = {} } = evt;
      const subcontractor = importedSubcontractors.find((u) => u.companyBusinessId === value);

      this.setState({
        selectedSubcontractor: subcontractor || '',
      }, () => this.checkIfChanged());
    };

    return (
      <fieldset disabled={!isAdmin && isEditState}>
        <InstallationServiceSubcontractor importedSubcontractors={importedSubcontractors}
                                          selectedSubcontractor={selectedSubcontractor}
                                          onChangeHandler={subcontractorChanged}
                                          isEditState={isEditState} />
      </fieldset>
    );
  };

  renderInstallationComments = () => {
    const {
      installationComment,
    } = this.state;

    const installationCommentChanged = (evt) => {
      this.setState({
        installationComment: evt.target.value,
      }, () => this.checkIfChanged());
    };

    return (
      <fieldset>
        <InstallationServiceComments installationComment={installationComment}
                                     onCommentChanged={installationCommentChanged} />
      </fieldset>
    );
  };

  renderParkingInfo = () => {
    const { session: { isAdmin = false } } = this.props;
    const {
      parkingInfo,
      isEditState,
    } = this.state;

    const parkingInfoChanged = (evt) => {
      this.setState({
        parkingInfo: evt.target.value,
      }, () => this.checkIfChanged());
    };

    return (
      <fieldset disabled={!isAdmin && isEditState}>
        <InstallationServiceParking parkingInfo={parkingInfo} onParkingInfoChanged={parkingInfoChanged} />
      </fieldset>
    );
  }

  updateDeviceStatus(device) {
    let anyUncompletedDeviceLeft = false;
    const updatedDeviceStatus = [];
    const { selectedDevices } = this.state;
    selectedDevices.forEach((getDevice) => {
      if (device === getDevice) {
        updatedDeviceStatus.push(device);
      } else {
        updatedDeviceStatus.push(getDevice);
      }
    });
    this.setState({ updatedDeviceStatus });
    selectedDevices.forEach((getDevice) => {
      if (getDevice.status !== undefined) {
        if (getDevice.status.value !== undefined && (getDevice.status.value === 'UNCOMPLETED')) {
          anyUncompletedDeviceLeft = true;
        }
      }
    });
    this.setState({ isAllDevicesCompleted: anyUncompletedDeviceLeft });
  }

  renderDeviceListForm = () => {
    const { session: { isAdmin = false }, translate } = this.props;
    const {
      importedDevices,
      selectedDevices,
      isEditState,
      currentFormStatus,
    } = this.state;

    const addToSelectedDeviceList = (device) => {
      if (device.shipmentType === undefined && selectedDevices && selectedDevices.length > 0) {
        device.shipmentType = selectedDevices[0].shipmentType;
      }
      selectedDevices.push(device);
      this.setState({
        selectedDevices,
      }, () => this.checkIfChanged());
    };

    const getStatusObject = (device) => {
      let status = {};
      if (device.status !== undefined) {
        status = device.status;
      }
      status.date = new Date();
      return status;
    };

    const onInputChange = (evt, isInstructionField) => {
      for (let i = 0; i < selectedDevices.length; i++) {
        if (selectedDevices[i].id === evt.target.id) {
          const statusObj = getStatusObject(selectedDevices[i]);
          if (!isInstructionField) {
            statusObj.reason = evt.target.value;
          } else {
            statusObj.instructions = evt.target.value;
          }
          selectedDevices[i].status = statusObj;
        }
      }
      this.setState({
        selectedDevices,
      }, () => this.checkIfChanged());
    };

    const removeFromSelectedDeviceList = (device) => {
      const array = [...this.state.selectedDevices];
      const index = array.indexOf(device);
      if (index !== -1) {
        array.splice(index, 1);
        if (array.length === 0) {
          toast.error(translate('service_installation.no_device_installation_document'));
        }
        this.setState({
          isAllDevicesCompleted: array.length === 0,
          hasAtleastOneDevice: array.length > 0,
          selectedDevices: array,
        }, () => this.checkIfChanged());
      }
    };

    const changeDeviceStatus = (device, status) => {
      for (let i = 0; i < selectedDevices.length; i++) {
        if (selectedDevices[i].id === device.id) {
          const statusObj = getStatusObject(selectedDevices[i]);
          statusObj.value = status;
          selectedDevices[i].status = statusObj;
        }
      }

      this.setState({
        selectedDevices,
      }, () => this.checkIfChanged());
    };

    const onNotInstalledClickHandler = (device) => {
      changeDeviceStatus(device, 'NOT_INSTALLED');
      this.updateDeviceStatus(device);
    };

    const onUncomplitedClickHandler = (device) => {
      changeDeviceStatus(device, 'UNCOMPLETED');
      this.updateDeviceStatus(device);
    };

    return (
      <fieldset disabled={!isAdmin && isEditState}>
        <InstallationServiceDevices importedDevices={importedDevices}
                                    selectedDevices={selectedDevices}
                                    onAddChangeHandler={addToSelectedDeviceList}
                                    onRemoveChangeHandler={removeFromSelectedDeviceList}
                                    isEditState={isEditState}
                                    currentFormStatus={currentFormStatus}
                                    onUncomplitedClickHandler={onUncomplitedClickHandler}
                                    onNotInstalledClickHandler={onNotInstalledClickHandler}
                                    deviceStatusValues={deviceStatusValues}
                                    onInputChange={onInputChange} />
      </fieldset>
    );
  };

  renderAdditionalServicesForm = () => {
    const {
      importedDeviceAdditionalProducts,
      selectedDeviceAdditionalProducts,
    } = this.state;

    const addToSelectedDeviceList = (additionalService) => {
      selectedDeviceAdditionalProducts.push(additionalService);
      this.setState({
        selectedDeviceAdditionalProducts,
      }, () => this.checkIfChanged());
    };

    const removeFromSelectedDeviceList = (additionalService) => {
      const array = [...this.state.selectedDeviceAdditionalProducts];
      const index = array.indexOf(additionalService);
      if (index !== -1) {
        array.splice(index, 1);
        this.setState({
          selectedDeviceAdditionalProducts: array,
        }, () => this.checkIfChanged());
      }
    };

    return (
      <InstallationServiceAdditionalServices importedDeviceAdditionalProducts={importedDeviceAdditionalProducts}
                                             selectedDeviceAdditionalProducts={selectedDeviceAdditionalProducts}
                                             onAddToDeviceList={addToSelectedDeviceList}
                                             onRemoveFromDeviceList={removeFromSelectedDeviceList} />
    );
  };

  installationAttachmentsRemove = (file, shouldTreatAsAdminEdit) => {
    const {
      installationAttachments,
      removedInstallationAttachmentsEdit,
    } = this.state;

    this.setState({
      adminEditInstallationAttachmentModalOpen: false,
    });

    if (shouldTreatAsAdminEdit) {
      this.setState({
        removedInstallationAttachmentsEdit: [
          ...removedInstallationAttachmentsEdit,
          file.id,
        ],
      });
    }
    const array = [...installationAttachments];
    const index = array.indexOf(file);
    if (index !== -1) {
      array.splice(index, 1);
      this.setState({
        installationAttachments: array,
      }, () => this.checkIfChanged());
    }
  };

  renderAttachmentsForm = () => {
    const {
      installationAttachments, newInstallationAttachmentsEdit, isEditState,
    } = this.state;

    const installationAttachmentsAdded = (evt) => {
      if (installationAttachments.filter((attachment) => (attachment.name === evt.target.files[0].name)).length === 0) {
        this.setState({
          installationAttachments: [
            ...installationAttachments,
            ...evt.target.files,
          ],
        }, () => this.checkIfChanged());
      } else {
        const { translate } = this.props;
        toast.error(translate('service_installation.file_already_exists'));
      }

      if (installationAttachments.filter((attachment) => (attachment.name === evt.target.files[0].name)).length === 0) {
        if (isEditState) {
          this.setState({
            newInstallationAttachmentsEdit: [
              ...newInstallationAttachmentsEdit,
              ...evt.target.files,
            ],
          });
        }
      }
    };

    const isNotNewlyAddedFileToEditState = (file) => !newInstallationAttachmentsEdit.includes(file);

    const installationAttachmentsRemoved = (file) => {
      if (isEditState && isNotNewlyAddedFileToEditState(file)) {
        this.setState({
          currentFileToBeRemoved: file,
          adminEditInstallationAttachmentModalOpen: true,
        });
      } else {
        this.installationAttachmentsRemove(file, false);
      }
    };

    return (
      <InstallationServiceAttachments installationAttachments={installationAttachments}
                                      newInstallationAttachmentsEdit={newInstallationAttachmentsEdit}
                                      isEditState={isEditState}
                                      onAttachmentsAdded={installationAttachmentsAdded}
                                      onAttachmentsRemoved={installationAttachmentsRemoved}
                                      onNotNewlyAddedFileToEditState={isNotNewlyAddedFileToEditState} />
    );
  };

  renderStatusSelectionForm = () => {
    const {
      currentFormStatus,
      isEditState,
      updatedStatusList,
    } = this.state;
    if (!isEditState) {
      return '';
    }

    const { translate } = this.props;

    const statusChanged = (evt) => {
      const { target: { value } = {} } = evt;
      const selectedStatus = statusList.find((u) => u.value === value);
      formStatusToSave = selectedStatus;
      this.setState({
        currentFormStatus: selectedStatus,
      }, () => this.checkIfChanged());
    };

    return (
      <fieldset>
        <div>
          <Table className="table-width" bordered>
            <thead className="table-head">
              <tr>
                <th>{translate('service_installation.select_status.title')}</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <h3 className="table-body-text-padding">
                    {translate('service_installation.select_status.title')}
                  </h3>
                  <div className="row">
                    <div className="col-sm-6 col-md-offset-3">
                      <Select value={currentFormStatus.value}
                              required
                              onChange={statusChanged}
                              data={updatedStatusList.map((status) => ({
                                value: status.value,
                                text: translate(`service_installation.select_status.${status.value}`),
                              }))} />
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </Table>
        </div>
      </fieldset>
    );
  };

  checkIfChanged = () => {
    const {
      shipmentNumber,
      shipmentType,
      consignorName,
      customerName,
      companyName,
      customerAddress,
      customerPostcode,
      customerCity,
      customerPhone,
      customerPhone2,
      customerEmail,
      invoiceReference,
      invoiceReference2,
      selectedDevices,
      selectedDeviceAdditionalProducts,
      selectedSubcontractor,
      installationComment,
      installationAttachments,
      currentFormStatus,
      currentFormStatusDB,
      editStateImportedTime,
      orderUncompletedCancelledReasonText,
      originalData,
    } = this.state;
    const data = {
      shipmentNumber,
      shipmentType,
      consignorName,
      customerName,
      companyName,
      customerAddress,
      customerPostcode,
      customerCity,
      customerPhone,
      customerPhone2,
      customerEmail,
      invoiceReference,
      invoiceReference2,
      selectedDevices,
      selectedDeviceAdditionalProducts,
      selectedSubcontractor,
      installationComment,
      installationAttachments,
      currentFormStatus,
      currentFormStatusDB,
      editStateImportedTime,
      orderUncompletedCancelledReasonText,
    };
    this.setState({
      isChanged: JSON.stringify(data) !== JSON.stringify(originalData),
    });
  };

  handleChange = (evt) => {
    if (evt.key === 'Enter') {
      if (evt.target.name === 'shipmentNumber') {
        evt.preventDefault();
        this.shipmentDataConfirmation(evt.target.value);
      }
    }
    this.setState({
      [evt.target.name]: evt.target.value,
    }, () => this.checkIfChanged());
  };

  onHandleChange24hTimePicker = (evt) => {
    if (evt.isStartTime) {
      this.setState({ editStateTimeStart: evt.pickedTime });
    } else {
      this.setState({ editStateTimeEnd: evt.pickedTime });
    }
  };

  pickedDate = (date) => {
    const selectedDate = new Date(date);
    const getCurrentYear = new Date(selectedDate).getFullYear();
    const modifiedSelectedDate = new Date(getCurrentYear, selectedDate.getMonth(), selectedDate.getDate());
    let { filter } = this.state;
    filter = {
      ...filter,
      editStateTimeDate: moment(date === undefined ? new Date() : modifiedSelectedDate)
        .startOf('day')
        .toDate(),
    };
    this.setState({
      filter,
      editStateTimeDate: date === undefined ? new Date() : modifiedSelectedDate,
    });
  };

  renderTimeData = () => {
    const {
      editStateImportedTime,
      editStateTimeDate,
      currentFormStatus,
      currentFormStatusDB,
    } = this.state;

    return (
      <div>
        <DayPickerInput value={dayjs(editStateTimeDate !== '' ? editStateTimeDate : new Date()).format('DD.MM.YYYY')}
                        onDayChange={this.pickedDate}
                        inputProps={{
                          required: 'required',
                          name: 'editStateTimeDate',
                          autoComplete: 'off',
                        }}
                        style={{ position: 'relative', top: '101px' }} />
        <TimeData editStateImportedTime={editStateImportedTime}
                  required
                  currentFormStatus={currentFormStatus}
                  currentDataFromDB={currentFormStatusDB}
                  currentDateFromDB={editStateImportedTime}
                  onHandleChange24hTimePicker={this.onHandleChange24hTimePicker}
                  statusList={statusList}
                  statusValues={statusValues} />
      </div>
    );
  };

  renderReasonFields = () => {
    const {
      orderUncompletedCancelledReasonText,
    } = this.state;

    return (
      <ReasonFields orderUncompletedCancelledReasonText={orderUncompletedCancelledReasonText}
                    handleChange={this.handleChange} />
    );
  };

  renderSelectDateOrReasonForm = () => {
    const {
      currentFormStatus,
      isEditState,
    } = this.state;
    if (!isEditState) {
      return '';
    }

    const {
      translate,
    } = this.props;

    const title = currentFormStatus.shouldShowTimeField
      ? translate('service_installation.select_time_title')
      : translate('service_installation.select_reason_title');

    return (
      <div>
        <Table bordered>
          <thead className="table-head">
            <tr>
              <th>{title}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                {currentFormStatus.shouldShowTimeField
                  ? this.renderTimeData()
                  : this.renderReasonFields()}
              </td>
            </tr>
          </tbody>
        </Table>
      </div>
    );
  };

  getInstalledDevicesAccessoriesHTMLElements() {
    let deviceName = '';
    let accessoryPrice = 0;
    const deviceAccessoriesModalNotificationText = [];
    const { currentLanguage, translate } = this.props;
    const { selectedDevices } = this.state;
    selectedDevices.forEach((device) => {
      const deviceAccessoriesPrice = device.accessories.map((accessoriesPrice) => accessoriesPrice.price);

      if (deviceAccessoriesPrice.length > 0) {
        accessoryPrice = deviceAccessoriesPrice[0];
      }

      if (device.accessories !== undefined && device.accessories.length > 0 && accessoryPrice !== 0
          && (device.accessories.map((deviceAccessory) => deviceAccessory.totalPrice !== undefined).includes(true))) {
        if (device.name.en_US !== undefined && currentLanguage === 'en') {
          deviceName = device.name.en_US;
        } else if (device.name.fi_FI !== undefined && currentLanguage === 'fi') {
          deviceName = device.name.fi_FI;
        }
        if (deviceName !== '') {
          deviceAccessoriesModalNotificationText.push(createElement('div', { className: 'device-name' },
            `${deviceName} - ${translate('service_installation.device_accessories_modal_msg')}`));
        }
      }
    });

    if (deviceAccessoriesModalNotificationText.length > 0) {
      return React.createElement('div', { className: 'device-list-accessories-msg' }, deviceAccessoriesModalNotificationText);
    }
    return '';
  }

  renderModal = () => {
    const { translate } = this.props;
    const { isAllDevicesCompleted, hasAtleastOneDevice } = this.state;
    const modalStyles = {
      modal: {
        width: '400px',
        padding: '2rem',
        overflowY: 'auto',
      },
    };

    const deviceDialougMessage = hasAtleastOneDevice ? translate('service_installation.all_devices_not_installed_modal_text')
      : translate('service_installation.no_device_installation_document');

    return (
      <div>
        <Modal open={submitFormModalOpen} onClose={this.closeSubmitFormModal} little showCloseIcon styles={modalStyles}>
          <div className="issue-item" style={{ paddingTop: '10px' }}>
            <div className="installation-document-image-div">
              {isAllDevicesCompleted === true ? deviceDialougMessage : ''}
            </div>
            <div className="installation-document-image-div">
              {isAllDevicesCompleted === true ? (
                <div className="col-sm-4" style={{ paddingLeft: '0' }}>
                  <button
                          onClick={(evt) => {
                            this.completeInstallationDocument(evt, false);
                          }}
                          href=""
                          className="button-background-color-cancel form-button-small form-input-shadow">
                    {translate('service_installation.modal_confirm_no')}
                  </button>
                </div>
              ) : (
                <div className="issue-item" style={{ paddingTop: '10px' }}>
                  <div className="installation-document-image-div">
                    {translate('service_installation.modal_text')}
                    { this.getInstalledDevicesAccessoriesHTMLElements() }
                  </div>
                  <div className="installation-document-image-div">
                    <div className="col-sm-4" style={{ paddingLeft: '0' }}>
                      <button
                              style={{ width: '100px' }}
                              onClick={(evt) => {
                                this.completeInstallationDocument(evt, true);
                              }}
                              href=""
                              className="form-button-small form-input-shadow">
                        {translate('service_installation.modal_confirm_yes')}
                      </button>
                    </div>
                    <div className="col-md-offset-4">
                      <button
                              onClick={(evt) => {
                                this.completeInstallationDocument(evt, false);
                              }}
                              href=""
                              className="button-background-color-cancel form-button-small form-input-shadow">
                        {translate('service_installation.modal_confirm_no')}
                      </button>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </Modal>
      </div>

    );
  };

  render() {
    const { translate } = this.props;
    const {
      isChanged,
      isSubmittingOrder,
      currentFormStatus,
    } = this.state;

    return (
      <div className="container normal-color">
        <Prompt message={translate('service_installation.confirm.leave-with-changes')}
                when={isChanged} />
        <form onSubmit={this.processShipmentOrder}
              onReset={this.reset}
              id="installationDocumentForm">
          {this.renderInstallationServiceForm()}
          {this.renderShipmentDataModal()}
          {this.renderDeviceListForm()}
          {this.renderSubcontractorForm()}
          {this.renderInstallationComments()}
          {this.renderAdditionalServicesForm()}
          {this.renderParkingInfo()}
          {this.renderAttachmentsForm()}
          {this.renderEditInstallationsAttachmentFileDeleteModal()}
          {this.renderStatusSelectionForm()}
          {currentFormStatus.shouldShowSelectDateOrReasonForm
                && this.renderSelectDateOrReasonForm()}
          <div>
            <div className="col-lg-5 form-submit-buttons" style={{ float: 'right' }}>
              <div className="col-xs-6">
                <Input disabled={isSubmittingOrder}
                       type="reset"
                       value={translate('form.reset')} />
              </div>
              <div className="col-xs-6">
                <Input disabled={isSubmittingOrder}
                       type="submit"
                       value={translate('form.submit')} />
              </div>
            </div>
          </div>
          {this.renderModal()}
        </form>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  translate: getTranslate(state.locale),
  currentLanguage: getActiveLanguage(state.locale).code,
  session: state.session,
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
  enableSubNavbar,
  setSubNavbar,
}, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(InstallationDocument);



// WEBPACK FOOTER //
// ./src/views/InstallationService.js